import ConversationMarker from "@/domain/entities/vistassistant/ConversationMarker";
import { cn } from "@/lib/utils";
import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cardClassName } from "./assistantClasses";

/**
 * Where the conversation was compacted: a separator, and what the assistant keeps in mind (the
 * summary written by the Api-Ai), folded.
 */
const CompactionMarker = ({ marker }: { marker: ConversationMarker }) => {
    const { t, i18n } = useTranslation();
    const time = marker.at.toLocaleTimeString(i18n.language, {
        hour: "2-digit",
        minute: "2-digit",
    });
    const label = t("vistassistant.compaction.marker", { time });

    return (
        <div className="flex w-full animate-opacity flex-col gap-2.5">
            <div
                aria-label={label}
                className="flex items-center gap-3 text-neutral-dark"
                role="separator"
            >
                <span className="h-px flex-1 bg-assistant-line" />
                <span className="text-xs font-medium">{label}</span>
                <span className="h-px flex-1 bg-assistant-line" />
            </div>
            {!!marker.summary && (
                <details className={cn(cardClassName, "group px-3.5 py-2.5")}>
                    <summary className="flex cursor-pointer list-none items-center gap-1.5 text-[13px] font-semibold text-primary-darker [&::-webkit-details-marker]:hidden">
                        <ChevronRight
                            aria-hidden
                            className="h-3.5 w-3.5 transition-transform group-open:rotate-90"
                        />
                        {t("vistassistant.compaction.summaryTitle")}
                    </summary>
                    <p className="mt-2 whitespace-pre-line text-sm leading-relaxed text-primary-darkest">
                        {marker.summary}
                    </p>
                </details>
            )}
        </div>
    );
};

export default CompactionMarker;
